export default __webpack_public_path__ + "static/media/icon_frases.e8c7a790.svg";